module.exports = __webpack_public_path__ + "img/19-small.67dca4a4.png";